import { Outlet, useOutletContext } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { selectUserProfile } from '../../features';
import { Roles } from '../../model';

const rolesHasEditAccess = [String(Roles.Manager), String(Roles.Admin)];
const rolesHasBillingAccess = [String(Roles.Admin)];
const rolesHasBillingViewAccess = [String(Roles.Manager),String(Roles.Admin)];
const rolesHasSnapshotAccess = [String(Roles.Operations)];
const rolesHasCSVExportAccess = [String(Roles.Manager), String(Roles.Admin)];

export type PermissionsContextType = {
    hasEditAccess: boolean;
    hasBillingAccess: boolean;
    hasBillingViewAccess: boolean;
    hasSnapshotAccess: boolean;
    hasCSVExportAccess: boolean;
};

export const PermissionsProvider = () => {
    const userProfile = useAppSelector(selectUserProfile);

    const hasEditAccess = userProfile?.roles
        ? userProfile.roles.some((role) => rolesHasEditAccess.includes(role))
        : false;
    const hasBillingAccess = userProfile?.roles
        ? userProfile.roles.some((role) => rolesHasBillingAccess.includes(role))
        : false;
    const hasBillingViewAccess = userProfile?.roles
        ? userProfile.roles.some((role) => rolesHasBillingViewAccess.includes(role))
        : false;
    const hasSnapshotAccess = userProfile?.roles
        ? userProfile.roles.some((role) => rolesHasSnapshotAccess.includes(role))
        : false;
    const hasCSVExportAccess = userProfile?.roles
        ? userProfile.roles.some((role) => rolesHasCSVExportAccess.includes(role))
        : false;

    return <Outlet context={{ hasEditAccess, hasBillingAccess, hasBillingViewAccess, hasSnapshotAccess, hasCSVExportAccess } as PermissionsContextType} />;
};

export function usePermissions() {
    return useOutletContext<PermissionsContextType>();
}
